module.exports = __webpack_public_path__ + "img/CF_Logo.c01e94e1.png";